//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Toast } from "vant";
export default {
  name: "index_",
  data: function data() {
    return {
      hospitalName: window.g.VUE_APP_HOSPITALNAME,
      hospitalPhone: window.g.VUE_APP_PHONE,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      hospitalMapPicSrc: window.g.VUE_APP_SUB_DIR + "/hospital/map.png",
      mapurl: window.g.VUE_APP_MAP_URL
    };
  },
  methods: {
    // 复制成功
    onCopy: function onCopy() {
      Toast.success('复制成功');
    },
    // 复制失败
    onError: function onError(e) {
      console.log(e);
      Toast.success('复制失败');
    }
  }
};